<div class="title" [ngClass]="containerClass()" (click)="toggleExpandedState()">
    @if (offerBadgeTemplate && activeOption && activeOption.badge) {
        <ng-container
            *ngTemplateOutlet="offerBadgeTemplate; context: { $implicit: { style: activeOption.badge.cssClass, title: activeOption.badge.text } }" />
    }

    @if (!isIconTemplate) {
        <span class="group-title" [style.color]="textColor">
            <ng-container
                *ngTemplateOutlet="
                    titleTemplate || defaultTitleTemplate;
                    context: { $implicit: activeOption ? activeOption.name : noSelectionText }
                " />
            <ng-template #defaultTitleTemplate let-title>{{ title }}</ng-template>
        </span>
        @if (expandable()) {
            @if (expanded()) {
                <span class="group-arrow dropdown-icon"><vn-icon name="theme-up" size="14" /></span>
            } @else {
                <span class="group-arrow dropdown-icon"><vn-icon name="theme-down" size="14" /></span>
            }
        }
    } @else {
        <ng-content select="[icon]" />
    }
</div>
<div
    [popper]="dropDown"
    [popperPlacement]="placement()"
    [popperApplyArrowClass]="'withoutArrow'"
    [popperTrigger]="NgxPopperjsTriggers.click"
    [popperApplyClass]="popperClass"
    [popperPreventOverflow]="false"
    [popperAppendTo]="targetViewport()"
    [popperBoundaries]="targetViewport()"
    [popperFlip]="popperFlip"></div>
<popper-content #dropDown>
    <div class="select" [ngClass]="contentClass">
        <ng-container *rxFor="let option of _options(); trackBy: optionTrackBy">
            @switch (option.type) {
                @case (optionType.Regular) {
                    <ng-container *ngTemplateOutlet="optionTemplate || defaultOptionTemplate; context: { $implicit: option }" />
                }
                @case (optionType.Special) {
                    <div class="option divider"></div>
                    <div class="option" [msAutomation]="option.automation" (click)="selectSpecialOption(option)">
                        <span class="option-name">{{ option.name }}</span>
                        <span
                            class="dropdown-popper-icon"
                            [ngClass]="getArrowClass(option.arrowType) === 'theme-right' ? 'dropdown-right-icon' : 'dropdown-left-icon'"
                            ><vn-icon size="12" [name]="getArrowClass(option.arrowType)"
                        /></span>
                    </div>
                }
            }
        </ng-container>
    </div>
</popper-content>

<ng-template #defaultOptionTemplate let-option>
    <div
        class="option"
        [class.active]="activeOption && activeOption.id === option.id"
        [msAutomation]="option.automation"
        (click)="selectOption(option)">
        @if (offerBadgeTemplate && option && option.badge) {
            <ng-container
                *ngTemplateOutlet="offerBadgeTemplate; context: { $implicit: { style: option.badge.cssClass, title: option.badge.text } }" />
        }
        {{ option.name }}
        @if (option.hasNewBadge) {
            <span class="dropdown-option-badge">{{ sitecore.globalMessages.NewBadgeText }}</span>
        }
    </div>
</ng-template>
